/*********************** Custom JS for Boost AI Search & Discovery  ************************/

console.log("BOOST CUSTOM");

//boostPFS.initInstantSearch();

console.log("SEARCH",window.boostSDAppConfig.searchSettings);

//window.boostSDAppConfig.searchSettings.enableInstantSearch = false;

/*var boostPFSInstantSearchConfig =
{
  search: {
  	suggestionPosition: 'right'
  }
};*/

/*SearchInput.prototype.customizeInstantSearch = function(){
	console.log("CUSTOMIZE INSTANT SEARCH");
  // The popup suggestion that is appended to <body> tag  var suggestionElement = this.$uiMenuElement;
  // The search <input name="q"> element  var searchElement = this.$element;
  // The id of the search input var searchBoxId = this.id;
};

// Bind the focus event on the search input* @param {Event} event DOM event
SearchInput.prototype._onFocusSearchBox = function(event) {

}

// Bind the typeahead event on the search input* @param {Event} event DOM event
SearchInput.prototype._onTypeSearchBoxEvent = function(event) { 
    Globals.currentTerm = event.target.value;
}*/

// Create a MediaQueryList instance
/*let mql = window.matchMedia("(max-width: 799px)");

// Add a listener that will be triggered whenever the media query's result changes
mql.addEventListener('change', (e) => {
  if (e.matches) {
    // The viewport has now less than or equal to 799px width
    console.log("Viewport is less than or equal to 799px width");

  } else {
    // The viewport has now more than 799px width
    console.log("Viewport is more than 799px width");

  }
});*/